export default __webpack_public_path__ + "static/media/mentibot-img.785b0b7f4a5a5c66b374ff455dd90273.png";